import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { errorResponse, okResponse, notFoundResponse } from '../../utils/response';
import { Token, UserCode, Company, EmployeeId } from '../../utils/users';
import * as storage from '../../utils/storage';

export function configMenu(userCode, company) {
    let url = 'menu/config?' + objectToQueryString({ userCode: userCode, company: company, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                if (response == "undefined") {
                    alert('undefined');
                }
                let configMenu = response.configMenu;

                if (configMenu == null) {
                    return notFoundResponse(response);
                }
                else {
                    saveConfig(configMenu);
                }

                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listMenu() {
    let url = 'menu/listMenu?' + objectToQueryString({ userCode: UserCode(), company: Company(), employeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listFavouritesMenus() {
    return fetch('menu/listFavouritesMenus', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function manageFavoritesMenus(codeMenu) {
    return fetch('menu/manageFavoritesMenus', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            codeMenu,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

function saveConfig(config) {
    storage.saveMenu(config)
}